import { render, staticRenderFns } from "./ticket.vue?vue&type=template&id=b5e370d0&scoped=true&"
import script from "./ticket.vue?vue&type=script&lang=js&"
export * from "./ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e370d0",
  null
  
)

export default component.exports